export default "__VITE_ASSET__81611869__"